
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"10","cy":"10","r":"10","fill":"#979797"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.295 8.915a1.004 1.004 0 01-.292-.509l-1.78.765H8.7l.595-.256zM10.693 8.914l.602.257h1.483l-1.795-.767a1.003 1.003 0 01-.29.51zM8.282 6.211h3.396c.074 0 .134-.06.134-.134V5H8.154v1.083c0 .071.058.128.128.128zM9.565 8.187c0 .233.192.424.428.424s.429-.19.429-.424a.427.427 0 00-.429-.424.427.427 0 00-.428.424zM10.286 6.793H9.7v.43a1.018 1.018 0 01.586 0v-.43z","fill":"#fff"}}),_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"5","y":"9","width":"10","height":"6"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 9.753h10v5.229H5V9.753z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.508 13.488c0 .16-.131.291-.293.291a.292.292 0 01-.293-.29v-2.275c0-.16.131-.291.293-.291.162 0 .293.13.293.291v2.274zm-1.606.018a.292.292 0 01-.585 0v-2.274c0-.16.131-.29.293-.29.161 0 .292.13.292.29v2.274zm-1.605-.031c0 .16-.131.29-.293.29a.292.292 0 01-.293-.29V11.2c0-.161.131-.292.293-.292.162 0 .293.13.293.291v2.275zm-1.606.047a.292.292 0 01-.585 0v-2.274c0-.16.131-.29.293-.29.161 0 .292.13.292.29v2.274zm-1.605.008c0 .16-.131.291-.293.291a.292.292 0 01-.293-.29v-2.275c0-.16.131-.291.293-.291.162 0 .293.13.293.291v2.274zm7.659-3.777h-9.49a.285.285 0 00-.255.283v4.662c0 .157.128.284.286.284h9.428a.285.285 0 00.286-.284v-4.662a.285.285 0 00-.255-.283z","fill":"#fff"}})])])
          )
        }
      }
    